module.exports = __webpack_public_path__ + "img/index-list-2.ee63ac90.png";